export enum EventCalendarType {
  Enhanced = "Enhanced",
  Engage = "Engage",
  Wellbeing = "Wellbeing"
}
